import { render, staticRenderFns } from "./NoCobertura.vue?vue&type=template&id=5a7fcf05"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7fcf05')) {
      api.createRecord('5a7fcf05', component.options)
    } else {
      api.reload('5a7fcf05', component.options)
    }
    module.hot.accept("./NoCobertura.vue?vue&type=template&id=5a7fcf05", function () {
      api.rerender('5a7fcf05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Toastification/Notificaciones/NoCobertura.vue"
export default component.exports